import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

type LumieOrbProps = {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

/** Hero orb sizing is inline on `lg` so auth/header refactors cannot drop dimensions. */
const LUMIE_ORB_LG_CLASS =
  'h-[min(42vw,380px)] w-[min(42vw,380px)] min-h-[280px] min-w-[280px] bg-[radial-gradient(circle_at_32%_26%,rgba(255,255,255,0.95),rgba(255,245,169,0.75)_24%,rgba(246,201,76,0.95)_48%,rgba(210,147,20,0.9)_100%)] shadow-[0_0_80px_rgba(246,201,76,0.45),0_40px_120px_rgba(216,164,30,0.35)]'

export function LumieOrb({ size = 'sm', className }: LumieOrbProps) {
  return (
    <span
      className={cn(
        'inline-block shrink-0 rounded-full',
        size === 'lg' &&
          LUMIE_ORB_LG_CLASS,
        size === 'md' &&
          'h-9 w-9 bg-[radial-gradient(circle_at_35%_30%,#fff7c2,#f6c94c_45%,#d99b16_100%)] shadow-[0_0_22px_rgba(246,201,76,0.55)]',
        size === 'sm' &&
          'h-6 w-6 bg-[radial-gradient(circle_at_35%_30%,#fff7c2,#f6c94c_45%,#d99b16_100%)] shadow-[0_0_18px_rgba(246,201,76,0.55)]',
        className
      )}
      aria-hidden
    />
  )
}

type LumieBrandMarkProps = {
  navigateHome?: boolean
  className?: string
  /** `sm` nav/header; `md` auth & marketing hero-adjacent panels */
  size?: 'sm' | 'md'
}

export function LumieBrandMark({ navigateHome = true, className, size = 'sm' }: LumieBrandMarkProps) {
  const content = (
    <>
      <LumieOrb size={size} />
      <span
        className={cn(
          'font-bold text-[var(--marketing-text,#1f2528)]',
          size === 'md' ? 'text-2xl sm:text-[1.65rem]' : 'text-xl'
        )}
      >
        Lumie Health
      </span>
    </>
  )

  if (navigateHome) {
    return (
      <Link
        to="/"
        className={cn(
          'inline-flex items-center no-underline hover:opacity-90',
          size === 'md' ? 'gap-3' : 'gap-2.5',
          className
        )}
      >
        {content}
      </Link>
    )
  }

  return (
    <div className={cn('inline-flex items-center', size === 'md' ? 'gap-3' : 'gap-2.5', className)}>{content}</div>
  )
}
